import { ConnectionCheck } from '../../utils/connection-check';
import { AppConstants } from '../../utils/appConstants.class';
import { BaseService } from '../services/baseService';

export class BaseComponent {
  constructor() {}

  public get isConnection() {
    return ConnectionCheck.isConnection;
  }

  public get currentUserId(): string {
    return localStorage.getItem(AppConstants.CURRENT_USER);
  }

  public get offlineInspectionId(): string {
    return localStorage.getItem(`${AppConstants.OFFLINE_INSPECTION}_${this.currentUserId}`);
  }

  public get currentAppType(): number {
    return +sessionStorage.getItem(AppConstants.CURRENT_APP_TYPE);
  }
}
